<template>
	<form v-if="!isSend" ref="form" action="/api/public/form/result/add/">
		<input type="hidden" name="code" value="e_reg_library" />
		<div class="form__row form__row_mrg-bot_xl">
			<label class="input">
				<custom-select
					v-model.trim="form.CATEGORY"
					:options="prepareCategories(categories)"
					:class="{ 'show-error': showInpError('CATEGORY') }"
					:hide-overflow="true"
					error-text="Это поле обязательно к заполнению"
					placeholder="Выберите категорию вопроса"
					name="form[CATEGORY]"
					form-key="CATEGORY"
					@set-selected="setSelectValue"
				/>
			</label>
		</div>
		<div class="form__row form__row_mrg-bot_xl">
			<label class="input">
				<input
					v-model="form.COMPANY"
					class="input__field"
					name="form[COMPANY]"
					type="text"
					placeholder="Наименование организации"
					autocomplete="off"
				/>
			</label>
		</div>
		<div class="form__row form__row_mrg-bot_xl">
			<label :class="{ 'show-error': showInpError('NAME') }" class="input">
				<input
					v-model="form.NAME"
					class="input__field"
					name="form[NAME]"
					type="text"
					placeholder="Как вас зовут?"
					autocomplete="off"
				/>
				<span class="input__error">Это поле обязательно к заполнению</span>
			</label>
		</div>
		<div class="form__row form__row_mrg-bot_xl">
			<label :class="{ 'show-error': showInpError('TELEPHONE') }" class="input">
				<input
					v-model.trim="form.TELEPHONE"
					class="input__field js--phone-mask"
					name="form[TELEPHONE]"
					type="tel"
					placeholder="Номер телефона"
					autocomplete="off"
					maxlength="17"
					@keypress="isNumber"
				/>
				<span class="input__error">{{ phoneErrorTxt }}</span>
			</label>
		</div>
		<div class="form__row form__row_mrg-bot_xl">
			<label :class="{ 'show-error': showInpError('EMAIL') }" class="input">
				<input
					v-model.trim="form.EMAIL"
					class="input__field"
					name="form[EMAIL]"
					type="email"
					placeholder="Email"
					autocomplete="off"
				/>
				<span class="input__error">{{ emailErrorTxt }}</span>
			</label>
		</div>
		<div class="form__row form__row_mrg-bot_xl">
			<label :class="{ 'show-error': showInpError('QUESTION') }" class="input">
				<textarea
					v-model.trim="form.QUESTION"
					class="input__field input__field_textarea input__field_size_small-textarea"
					name="form[QUESTION]"
					placeholder="Интересующая информация"
					autocomplete="off"
					row="4"
				/>
				<span class="input__error">Это поле обязательно к заполнению</span>
			</label>
		</div>
		<div class="form__conf-policy">
			<div
				class="gos-faq-form form__label-wrapper"
				:class="{ 'show-error': showInpError('isCheck') }"
			>
				<label for="gos-faq-form-agree" class="checkbox">
					<input
						id="gos-faq-form-agree"
						v-model="form.isCheck"
						type="checkbox"
						name="form[agreement_id]"
						:value="idPersPr"
					/>
					<span class="checkbox__field" />
					<p class="form__checkbox-text">
						<span>Согласен на обработку</span>
						<span
							:data-href="idPersPr"
							class="form__link-colored"
							@click.prevent="openConditions"
						>
							персональных данных
						</span>
						<span> в соответствии с </span>
						<a
							class="form__link-colored"
							href="/upload/documents/personal_data_process.pdf"
							target="_blank"
						>
							политикой
						</a>
					</p>
				</label>
				<span class="input__error">Подтвердите согласие</span>
			</div>
			<div class="form__submit">
				<button
					class="button button_type_primary"
					type="submit"
					@click.prevent="handlerSendForm()"
				>
					<my-preloader
						v-if="isSubmitting"
						:add-class="'n-py-0 n-pr-1'"
						:add-class-preloader="'w-20px'"
					/>
					<template v-if="isSubmitting"> Отправка </template>
					<template v-else> Отправить </template>
				</button>
			</div>
		</div>
		<div ref="smartcaptcha"></div>
	</form>
	<div v-else class="form__success-block">
		<div class="form__success-icon">
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM13.1655 7.37377C13.556 6.98325 14.1892 6.98325 14.5797 7.37377L14.7369 7.53091C15.1274 7.92143 15.1274 8.5546 14.7369 8.94512L10.7299 12.9521L9.15857 11.3807L13.1655 7.37377ZM10.7299 12.9521L9.15849 14.5234L5.15155 10.5165C4.76103 10.1259 4.76103 9.49278 5.15155 9.10226L5.30869 8.94512C5.69921 8.5546 6.33237 8.55459 6.7229 8.94511L10.7299 12.9521Z"
					fill="#8BC540"
				/>
			</svg>
		</div>
		<p class="form__title">Ваш запрос отправлен!</p>
		<p v-if="false" class="form__text">
			Менеджер свяжется с&nbsp;вами, чтобы обсудить детали
		</p>
	</div>
	<ui-modal
		v-show="isShowConditions"
		ref="uiModal"
		:target="idPersPr"
		:need-close-button="true"
		class="modal_conditions"
		@modal-close="isShowConditions = false"
	>
		<template v-if="contentPersPr">
			<div
				class="ui-modal-container__header ui-modal-container__header-conditions"
				v-html="headerTitle"
			/>
			<div
				class="ui-modal-container__body ui-modal-container__body-conditions"
				v-html="contentPersPr"
			/>
		</template>
		<template v-else>
			<div class="conditions s3">
				<div class="conditions-inner" style="overflow: hidden">
					загрузка согласия...
				</div>
			</div>
			<my-preloader :add-class="'n-py-8 n-px-8'" />
		</template>
	</ui-modal>
</template>

<script>
import getConditions from './mixins/getCondition'
import captchaMixin from '@/js/vue-components/mixins/captcha'
import CustomSelect from './SelectRegion'
import phoneMask from '../modules/phone-mask'
import FormHelper from './mixins/form-heper'

export default {
	name: 'GosFaqForm',
	components: {
		CustomSelect,
	},
	mixins: [FormHelper, getConditions, captchaMixin],
	props: {
		categories: {
			type: Object,
			default() {
				return {}
			},
		},
	},
	data() {
		return {
			form: {
				CATEGORY: '',
				NAME: '',
				TELEPHONE: '',
				EMAIL: '',
				QUESTION: '',
				isCheck: false,
			},
			validErrorTxt: 'Заполните поле',
			idPersPr: 's3',
			isShowConditions: false,
		}
	},
	mounted() {
		phoneMask(document.querySelectorAll('.js--phone-mask')) // инициируем маску для телефона
	},
	updated() {
		phoneMask(document.querySelectorAll('.js--phone-mask')) // инициируем маску для телефона
	},
	methods: {
		/**
		 * Проверка ввода номера телефона на число и длину строки в 16 символов
		 */
		isNumber(evt) {
			if (evt.target.value.length <= 16) {
				const charCode = evt.which ? evt.which : evt.keyCode
				if (charCode < 48 || charCode > 57) {
					evt.preventDefault()
				}
			} else evt.preventDefault()
		},
		handlerSendForm() {
			this.showValidationError = true
			if (this.isFormValid()) {
				this.isSubmitting = true
				//- вызывает из ./mixins/captcha
				this.initCaptcha()
			}
		},
		submitFormAfterCaptchaCheck(token) {
			const $form = this.$refs.form
			const formData = new FormData($form)
			formData.set('agreement', 1)

			this.axios
				.post($form.action, formData, {
					headers: {
						'Content-type': 'multipart/form-data',
					},
				})
				.then(({ data }) => {
					if (data.success === true) {
						this.isSend = true
						setTimeout(() => {
							this.resetForm()
						}, 10000)
						if (typeof submitCleverData !== 'undefined') {
							submitCleverData('gos-faq-fos-send')
						}
					} else {
						alert(`Ошибка: ${data.message}`)
					}
				})
				.catch(error => {
					alert(error)
				})
		},
		prepareCategories(items) {
			const result = []
			for (const key in items) {
				result.push(items[key])
			}
			return result
		},
		openConditions() {
			this.showModal()
			this.isShowConditions = true
		},
	},
}
</script>
